import { PartialCustomTabData } from "../../../../../constants/constant-types";

export const practiceSettingsData: PartialCustomTabData[] = [
  {
    value: "profile",
    path: "",
    label: "Profile",
  },
  {
    value: "locations",
    path: "locations",
    label: "Locations",
  },
  {
    value: "departments",
    path: "departments",
    label: "Departments",
  },
  {
    value: "referring-agency",
    path: "referring-agency",
    label: "Referring Agency",
  },
  {
    value: "payers",
    path: "payers",
    label: "Payers",
  },
  // {
  //   value: "print_configuration",
  //   path: "print-configuration",
  //   label: "Print Configuration",
  // },
  {
    value: "configuration",
    path: "configuration",
    label: "Configuration",
  },
  {
    value: "audit-log",
    path: "audit-log",
    label: "Audit Log",
  },
  // {
  //   value: "patient_id_configuration",
  //   path: "patient-id-configuration",
  //   label: "Patient ID Configuration",
  // },
  {
    value: "appointment-type-configuration",
    path: "appointment-type-configuration",
    label: "Appointment Type Configuration",
  },
];

export const AUDIT_LOG_DATE_RANGE_OPTIONS = [
  { value: "TODAY", label: "Today" },
  { value: "YESTERDAY", label: "Yesterday" },
  { value: "LAST_7_DAYS", label: "Last 7 Days" },
  { value: "LAST_30_DAYS", label: "Last 30 Days" },
  { value: "LAST_90_DAYS", label: "Last 90 Days" },
  { value: "THIS_MONTH", label: "This Month" },
  { value: "LAST_MONTH", label: "Last Month" },
  { value: "CUSTOM_RANGE", label: "Custom Range" },
] as const;

export const AUDIT_LOG_CUSTOM_RANGE = "CUSTOM_RANGE";

export const AUDIT_LOG_DATE_RANGE_KEYS = [
  "date_range",
  "startDate",
  "endDate",
] as const;

export type AuditLogDateRangeType =
  (typeof AUDIT_LOG_DATE_RANGE_OPTIONS)[number]["value"];

export type AuditLogFilters = {
  date_range?: AuditLogDateRangeType;
  startDate?: string;
  endDate?: string;
  patient: string;
  user: string;
  category: string;
  action: string;
  logType: string;
  ipAddress?: string;
};

export const auditLogFiltersInitial: AuditLogFilters = {
  date_range: undefined,
  startDate: undefined,
  endDate: undefined,
  patient: "",
  user: "",
  category: "",
  action: "",
  logType: "",
  ipAddress: undefined,
};

export const SEARCH_PLACEHOLDER_BY_TAB: Record<string, string | undefined> = {
  locations: "Search By Name, City, State",
  departments: "Search By Name, City, State",
  "referring-agency": "Search By Agency Name, Specialty",
};

export const PROFILE_DETAIL_CARD_TABS = [
  "locations",
  "departments",
  "referring-agency",
  "payers",
];
